import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
// logger插件（Vuex日志插件）
// import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

// 设置调试工具(开发模式中使用)
const debug = process.env.NODE_ENV !== 'production'
const modulesFiles = require.context('./modules', true, /\.js$/)

// 把modules下面的所有模块都加载
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

// 注册Vuex工厂
export default new Vuex.Store({
  modules,
  getters,
  strict: debug // 严格模式
  // plugins: debug ? [createLogger()] : [] // 调试日志
})



// WEBPACK FOOTER //
// ./src/store/index.js